import { QuestionOptionPrice as Question } from "@/components/features/items/edit/option/_shared/ui/components/price";

import { useOptionPrice } from "./hooks";

type Props = {
	isPriceDisabled?: boolean;
};

export const QuestionOptionPrice = ({ isPriceDisabled }: Props) => {
	const {
		isEdited,
		hasError,

		billingTypeTerm,
		billingTypeTermOptions,
		onSetBillingTypeTerm,
		shouldShowBillingTypeTerm,

		price,
		onSetPriceAmount,
	} = useOptionPrice();

	return (
		<Question
			isEdited={isEdited}
			hasError={hasError}
			billingTypeTerm={billingTypeTerm}
			billingTypeTermOptions={billingTypeTermOptions}
			onSetBillingTypeTerm={onSetBillingTypeTerm}
			shouldShowBillingTypeTerm={shouldShowBillingTypeTerm}
			price={price}
			onSetPriceAmount={onSetPriceAmount}
			isPriceDisabled={isPriceDisabled}
		/>
	);
};

QuestionOptionPrice.displayName = "QuestionOptionPrice";
